import { motion } from 'framer-motion';
import { MoonStar, SunMedium } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      aria-label="Toggle theme"
      className="relative flex h-11 w-11 items-center justify-center rounded-full border border-slate-200/60 bg-white/80 shadow-sm backdrop-blur-lg transition-all duration-200 hover:scale-105 hover:border-brand-400 hover:shadow-elevation dark:border-slate-700/80 dark:bg-slate-900/80 dark:hover:border-brand-300"
      whileTap={{ scale: 0.95 }}
    >
      <SunMedium
        className="absolute h-5 w-5 text-amber-500 transition-opacity duration-200 dark:opacity-0"
      />
      <MoonStar
        className="absolute h-5 w-5 text-sky-300 transition-opacity duration-200 dark:opacity-100 opacity-0"
      />
      <span className="sr-only">
        Switch to {theme === 'dark' ? 'light' : 'dark'} mode
      </span>
    </motion.button>
  );
};
